import {
    GetPDM_MA_TypeList,
    GetPDM_MA_TypeListByPage,
    GetPDM_MA_TypeEntity,
    CreatePDM_MA_TypeEntity,
    UpdatePDM_MA_TypeEntity,
    DeletePDM_MA_TypeEntity,
    SetPDM_MA_TypeIsValid
} from '@/api/pdm/ma/maType'

import msg from '@/config/notify'
import dlg from '@/config/dialog'


export const PdmMaType = {
    namespaced: true,
    state: {
        PdmMaTypeList: [],
        PdmMaTypeListLoading: false,
        PdmMaTypeEntity: null,
        PdmMaTypeShowDlg: false,
    },
    mutations: {
        setPdmMaTypeList(state, dataList) {
            state.PdmMaTypeList = [...dataList]
        },
        setPdmMaTypeListLoading(state, visible) {
            state.PdmMaTypeListLoading = visible
        },
        setPdmMaTypeShowDlg(state, visible) {
            state.PdmMaTypeShowDlg = visible
        },
        setPdmMaTypeEntity(state, entity) {
            state.PdmMaTypeEntity = entity
        },
    },
    actions: {
        //创建预约套餐对象
        actCreatePdmMaType({ commit }, parm) {
            return new Promise((resolve, reject) => {
                CreatePDM_MA_TypeEntity(parm).then(res => {
                    if (res.Code == 0) {
                        res.Data.IsValid = 0;
                        commit('setPdmMaTypeEntity', res.Data)
                        commit('setPdmMaTypeShowDlg', true)
                        console.log(`output->res.Data`,res.Data)
                         //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        reject(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载预约套餐对象
        actGetPdmMaTypeEntity({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmMaTypeListLoading', true)
                GetPDM_MA_TypeEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaTypeEntity', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmMaTypeListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载预约套餐列表
        actGetPdmMaTypeList({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmMaTypeListLoading', true)
                GetPDM_MA_TypeList(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaTypeList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmMaTypeListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //分页加载预约套餐列表
        actGetPdmMaTypeListByPage({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmMaTypeListLoading', true)
                GetPDM_MA_TypeListByPage(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaTypeList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                       // msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmMaTypeListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //保存预约套餐信息
        actUpdatePdmMaType({ commit,state }, parm) {
            return new Promise((resolve) => {
                UpdatePDM_MA_TypeEntity(parm).then(res => {
                    if (res.Code == 0) {
                        var temp = [...state.PdmMaTypeList]
                        const index = state.PdmMaTypeList.findIndex(item => item.TypeID === res.Data.TypeID)
                        if (index > -1) {
                          // 如果已经存在该 ItemID 对应的数据，则进行更新操作
                          temp.splice(index, 1, res.Data)
                        } else {
                          // 否则进行插入操作
                          temp.push(res.Data)
                        }
                        commit('setPdmMaTypeList', temp)
                        commit('setPdmMaTypeShowDlg', false)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_MA_Type
        actEditPdmMaTypeData({ commit }, entity) {
            return new Promise((resolve) => {
                let parm = {                    
                    TypeID : entity.TypeID
                }
                GetPDM_MA_TypeEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaTypeEntity', res.Data)
                        commit('setPdmMaTypeShowDlg', true)
                        // msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_MA_Type ,传对象过来
        actEditPdmMaType({ commit }, entity) {
            return new Promise(() => {
                commit('setPdmMaTypeEntity', entity)
                commit('setPdmMaTypeShowDlg', true)
            }).catch(err => {
                console.log(err)
            })
        },
        //删除PDM_MA_Type
        actDeletePdmMaType({ commit }, e) {
            return new Promise((resolve) => {
                dlg.confirm("是否确定要删除当前预约套餐？").onOk(() => {
                    DeletePDM_MA_TypeEntity(e).then(res => {
                        if (res.Code == 0) {
                            commit('setPdmMaTypeShowDlg', false)
                            msg.success("删除预约套餐成功。")
                            resolve(res)
                        } else {
                            dlg.alert("删除预约套餐失败，原因:" + res.Message)
                            //msg.success("删除预约套餐失败，原因:" + res.Message)
                            resolve(res)
                        }
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        },
        // 设置套餐分类是否禁用
        actSetPDM_MA_TypeIsValid({ commit,state }, parm) {
            return new Promise((resolve) => {
                SetPDM_MA_TypeIsValid(parm).then(res => {
                    if (res.Code == 0) {
                        var temp = [...state.PdmMaTypeList]
                        const index = temp.findIndex(item => item.TypeID === res.Data.TypeID)
                        temp.splice(index, 1, res.Data)
                        commit("setPdmMaTypeList",temp)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
    }
}
